import { joinFiltersWithAnd, joinFiltersWithOr } from 'lib/algolia';

const europeanChampionshipTeamsSlugs = ['england', 'spain'] as const;

export const useEuropeanChampionshipFilterValue = (
  europeanChampionshipFilter: string | undefined
) => {
  if (!europeanChampionshipFilter) return null;
  return joinFiltersWithAnd([
    'NOT card_edition.display_name:Legend',
    joinFiltersWithOr(
      europeanChampionshipTeamsSlugs.map(
        slug => `active_national_team.slug:${slug}`
      )
    ),
  ]);
};
